import type { GamesFiltersParamsPayload } from '../games/games.schema';
import { bannerQueryOptions } from '../banners/banners.queries';
import { gameQueryOptions } from '../games/games.queries';
import { providerQueryOptions } from '../providers';

export const LOBBY_QUERY_OPTIONS = { staleTime: Infinity } as const;

export const DEFAULT_LOBBY_PARAMS = {
  page: 1,
  limit: 9,
};

export const lobbyQueryOptions = {
  publicBanners: () => bannerQueryOptions.allPublicBanners(LOBBY_QUERY_OPTIONS),
  gamesByCategory: (params?: GamesFiltersParamsPayload) =>
    gameQueryOptions.list({ params: { ...DEFAULT_LOBBY_PARAMS, ...params }, options: LOBBY_QUERY_OPTIONS }),
  providers: () =>
    providerQueryOptions.list({ limit: 50, filters: { isActive: true }, sort: { order: 'asc' } }, LOBBY_QUERY_OPTIONS),
};
